import React, { useEffect, useState } from "react";
import { Form, Card, Row, Col, Offcanvas, Badge } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { studyLabManagementServices } from "../../../../APIServices/studyLabManagementServices";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studySiteManagementServices } from "../../../../APIServices/CTMS/SiteManagement/studySiteManagementServices";
import SplitPane from "react-split-pane";
import Swal from "sweetalert2";
import LabManagementProperties from "../LabManagementProperties/LabManagementProperties";
import UpdateLabManagement from "./UpdateLabManagement";
import DeletedLabManagement from "./DeletedLabManagement";
import TableProperties from "../LabManagementProperties/TableProperties";
import LabManagementActivities from "../LabManagementProperties/LabManagementActivities";
import UseToggle from "../../../../Hooks/UseToggle";
import AddLabManagementForm from "./AddLabManagementForm";
import Pagination from "../../../Pagination";
import ManageLabOrder from "./ManageLabOrder";

const LabManagementDataList = ({ onMouseDown, tableRef }) => {
  const [searchData, setSearchData] = useState("");
  const [rowId, setRowId] = useState("");
  const [rowData, setRowData] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [activityLoader, setActivityLoader] = useState(false);
  const [activeTab, setActiveTab] = useState("properties");
  const [labManagementColumns, setLabManagementColumns] = useState([]);
  const [labManagementColumnsCount, setLabManagementColumnsCount] = useState(0);
  const [tableColumns, setTableColumns] = useState({});
  const [labManagementRows, setLabManagementRows] = useState([]);
  const [labManagementRowsCount, setLabManagementRowsCount] = useState(0);
  const [labManagementDeletedRows, setLabManagementDeletedRows] = useState([]);
  const [labManagementDeletedRowsCount, setLabManagementDeletedRowsCount] = useState(0);
  const [labManagementActivity, setLabManagementActivity] = useState([]);
  const [labManagementActivityCount, setLabManagementActivityCount] = useState(0);
  const [siteUniqueId, setSiteUniqueId] = useState("");
  const {
    toggle, setToggle,
    toggle1, setToggle1,
    toggle2, setToggle2,
    toggle3, setToggle3,
    toggle4, setToggle4,
    toggle5, setToggle5
  } = UseToggle();
  const [loading, setLoading] = useState(false);
  let { studyId } = useParams();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const ctmsPermission = JSON.parse(localStorage.getItem("ctmsPermissionData"));
  const [buttonLoader, setButtonLoader] = useState(false);

  const [siteId, setSiteId] = useState("");
  const [siteList, setSiteList] = useState([]);

  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const role = JSON.parse(localStorage.getItem("role"));
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  let modifiedMode = StudyMode === "SDV QC Mode" ? "QC" : StudyMode === "SDV QC Mode" ? "QC" : StudyMode === "SDV Live Mode" ? "LIVE" : StudyMode === "Live Mode" ? "LIVE" : StudyMode === "DBP Mode" && "DBP";

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const getStudySiteBasedonAccess = async () => {
    let data = await studySiteManagementServices.getStudySiteBasedonAccess(studyId, LoginCat, StudyMode);
    let sites = data?.data || [];
    setSiteList(sites);
    setSiteId(sites[0]?.siteId);
  };

  const getStudyLabManagementColumnData = async (e) => {
    setLoading(true);
    let data = await studyLabManagementServices.getStudyLabManagementColumnData(
      "active",
      studyId
    );
    setLabManagementColumns(data?.data || []);
    setLabManagementColumnsCount(data?.count || 0);
    setLoading(false);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(labManagementRowsCount / itemsPerPage);

  const getStudyLabManagementRowData = async (e) => {
    setLoading(true);
    let data = await studyLabManagementServices.getStudyLabManagementRowData(
      "active",
      studyId,
      siteId,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setLabManagementRows(data?.data || []);
    setLabManagementRowsCount(data?.count || 0);
    setRowData("");
    setRowId("");
    setLoading(false);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedStudyLabManagementRowData = async (
    siteUniqueId,
    pageNumberDeleted,
    itemsPerPageDeleted
  ) => {
    let data = await studyLabManagementServices.getStudyLabManagementRowData(
      "deleted",
      studyId,
      siteUniqueId || siteId,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setLabManagementDeletedRows(data?.data || []);
    setLabManagementDeletedRowsCount(data?.count || 0);
  };

  const getTablePropertiesData = async (e) => {
    let data = await studyOtherSettingsServices.getTablePropertiesData(
      "studyLabManagement",
      studyId
    );
    setTableColumns(data?.data || []);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "labManagementData",
      studyId,
      rowData?.testId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    let result = data?.data || [];
    let updateData = result?.filter(item => item.actionType === "update");
    let otherData = result?.filter(item => item.actionType !== "update")?.length;
    setLabManagementActivity(updateData);
    setLabManagementActivityCount((data?.count || 0) - otherData);
    setActivityLoader(false);
  };

  useEffect(() => {
    getStudyLabManagementColumnData();
    getTablePropertiesData();
  }, []);

  useEffect(() => {
    if (studyId) {
      getStudySiteBasedonAccess();
    }
  }, [studyId]);

  useEffect(() => {
    getStudyLabManagementRowData();
  }, [siteId, searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreStudyLabManagementRow = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} test!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.id = id;
        userData.studyId = studyId;
        userData.type = type;
        let data = await studyLabManagementServices.softDeleteRestoreStudyLabManagementRow(userData);
        if (data?.statusCode === 200) {
          getStudyLabManagementRowData();
          getDeletedStudyLabManagementRowData(siteUniqueId, pageNumberDeleted, itemsPerPageDeleted);
          setRowId("");
          if (type === "restore") {
            getDeletedStudyLabManagementRowData(siteUniqueId, pageNumberDeleted, itemsPerPageDeleted);
            setToggle1();
          }
        }
      }
    });
  };

  const updateTableProperties = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Update Table Property!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Update it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.studyId = studyId;
        userData.type = "studyLabManagement";
        userData.columns = tableColumns;
        let data = await studyOtherSettingsServices.updateTableProperties(userData);
        if (data?.statusCode === 200) {
          getStudyLabManagementRowData();
          getTablePropertiesData();
        }
      }
      setButtonLoader(false);
    });
  };

  const getVisibleColumns = () => {
    if (role === "ctms") {
      return labManagementColumns?.filter(col =>
        !(col?.columnName === "UPPERRANGE" || col?.columnName === "LOWERRANGE") &&
        !tableColumns[col?.columnName]
      ) || [];
    }
    return labManagementColumns?.filter(col => !tableColumns[col?.columnName]) || [];
  };

  const renderValue = (row, column) => {
    const value = row?.row[column?.columnName];
    if (!value) return "—";
    return value;
  };

  const handleTabClick = (tab, row, fetchData = false) => {
    setRowData(row);
    setRowId(row?._id);
    setActiveTab(tab);
    if (tab === "test Activities" && fetchData) {
      getStudyAuditTrials(1, 10);
    }
  };

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          {!ctmsPermission.ctmsReadOnlyAccess && role === "ctms" && (
            <>
              <i
                title={isFormOpen ? "Close Form" : "Add Lab"}
                onClick={() => {
                  setIsFormOpen(!isFormOpen);
                  setRowId("");
                }}
                className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"}`}
              />
              <div className="vr"></div>
            </>
          )}
          {labManagementRowsCount > 0 && (
            <>
              <div className="position-relative">
                <Form.Control
                  type="Search"
                  onChange={(e) => setSearchData(e.target.value)}
                  value={searchData}
                  placeholder="Search..."
                  style={{ width: 200, padding: "3px 10px" }}
                />
                <CiSearch
                  className="CP position-absolute bg-white"
                  title="Search"
                  style={{ width: 15, top: 4, right: 7 }}
                />
              </div>
              <div className="vr"></div>
            </>
          )}
          <Form.Select
            value={siteId}
            style={{ width: 150, padding: "3px 10px" }}
            onChange={(e) => setSiteId(e.target.value)}
          >
            <option value="" hidden>
              Select Site
            </option>
            {siteList.map((item, index) => (
              <option key={index} value={item.siteId}>
                {item.row?.SITEID}
              </option>
            ))}
          </Form.Select>
        </div>
        <div className="hstack gap-2">
          {labManagementRowsCount > 0 && (
            <>
              {ctmsPermission?.manageOrder &&
                <button
                  onClick={() => {
                    setToggle5();
                  }}
                  className="updateProfile"
                  style={{ fontSize: 12 }}
                >
                  Manage Order
                </button>
              }
              <button
                onClick={() => {
                  setToggle2();
                  getTablePropertiesData();
                }}
                className="updateProfile"
                style={{ fontSize: 12 }}
              >
                Table Properties
              </button>
            </>
          )}
          {role === "ctms" && !ctmsPermission.ctmsReadOnlyAccess && (
            <button
              onClick={() => {
                setToggle1();
                getDeletedStudyLabManagementRowData(siteUniqueId, pageNumberDeleted, itemsPerPageDeleted);
              }}
              className="updateProfile"
            >
              Deleted History
            </button>
          )}
        </div>
      </div>

      <SplitPane
        split="vertical"
        minSize={20}
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        defaultSize={isFormOpen ? "20%" : "100%"}
      >
        {isFormOpen && (
          <AddLabManagementForm
            getStudyLabManagementRowData={getStudyLabManagementRowData}
          />
        )}
        {loading ? (
          <PageLoader />
        ) : labManagementRowsCount === 0 ? (
          <NoDataFoundTable MSG={"Lab management data not Found!"} />
        ) : labManagementRows?.length === 0 ? (
          <NoDataFoundTable MSG={"Search Lab management data not Found!"} />
        ) : (
          <>
            <div className="p-2">
              <Row className="g-3">
                {labManagementRows?.map((row, index) => {
                  const visibleColumns = getVisibleColumns();
                  return (
                    <Col key={row._id} xs={12}>
                      <Card className="app-card">
                        <Card.Body>
                          {/* Header with Action Buttons */}
                          <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                            <div className="d-flex align-items-center gap-2">
                              <span className="text-muted small">
                                Sr. {index + 1 + startIndex}
                              </span>
                              {/* Properties Button */}
                              <button
                                className="updateProfile"
                                style={{ fontSize: 10, padding: "2px 8px" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleTabClick("properties", row);
                                  setToggle4();
                                }}
                              >
                                Properties
                              </button>

                              {/* Test Activities Button */}
                              <button
                                className="updateProfile"
                                style={{ fontSize: 10, padding: "2px 8px" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleTabClick("test Activities", row, true);
                                  setToggle3();
                                }}
                              >
                                Test Activities
                              </button>
                            </div>
                            <div className="d-flex gap-1 flex-wrap">
                              {/* Edit Button - Only for non-ctms roles */}
                              {role === "ctms" && !ctmsPermission.ctmsReadOnlyAccess && (
                                <>
                                  <button
                                    className="updateProfile"
                                    style={{ fontSize: 10, padding: "2px 8px" }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setRowData(row);
                                      setToggle();
                                    }}
                                  >
                                    Edit
                                  </button>
                                  <button
                                    className="removeProfile"
                                    style={{ fontSize: 10, padding: "2px 8px" }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      softDeleteRestoreStudyLabManagementRow(row?._id, "delete");
                                    }}
                                  >
                                    Delete
                                  </button>
                                </>
                              )}
                            </div>
                          </div>

                          {/* Lab Details - Full Width Layout */}
                          <Row>
                            {visibleColumns.map((column, idx) => {
                              const value = renderValue(row, column);
                              return (
                                <Col key={column._id || idx} xs={4} md={3} lg={2} className="mb-2">
                                  <div className="text-muted small" style={{ fontSize: "11px" }}>
                                    {column?.columnLabel}
                                  </div>
                                  <div className="fw-semibold" style={{ fontSize: "14px" }}>
                                    {value || "—"}
                                  </div>
                                </Col>
                              );
                            })}
                          </Row>
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            </div>

            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={labManagementRowsCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
      </SplitPane>

      {/* Manage Lab Order Offcanvas */}
      <ManageLabOrder
        Show={!toggle5}
        Hide={setToggle5}
        Title="Manage Lab Order"
        labRows={labManagementRows}
        getStudyLabManagementRowData={getStudyLabManagementRowData}
      />

      {/* Edit Lab Management Modal */}
      <UpdateLabManagement
        Show={!toggle}
        Hide={setToggle}
        rowData={rowData}
        setRowId={setRowId}
        labManagementColumns={labManagementColumns}
        getStudyLabManagementRowData={getStudyLabManagementRowData}
        Title={"Update Range"}
        modifiedMode={modifiedMode}
      />

      {/* Table Properties Modal */}
      <TableProperties
        Show={!toggle2}
        Hide={setToggle2}
        Title={"Table Properties"}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        labManagementColumns={labManagementColumns}
        tableColumns={tableColumns}
        setTableColumns={setTableColumns}
        buttonLoader={buttonLoader}
        updateTableProperties={updateTableProperties}
        role={role}
      />

      {/* Deleted Lab Management Modal */}
      <DeletedLabManagement
        Show={!toggle1}
        Hide={setToggle1}
        studyId={studyId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        siteList={siteList}
        labManagementDeletedRows={labManagementDeletedRows}
        getDeletedStudyLabManagementRowData={getDeletedStudyLabManagementRowData}
        labManagementDeletedRowsCount={labManagementDeletedRowsCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        setSiteUniqueId={setSiteUniqueId}
        siteUniqueId={siteUniqueId}
        softDeleteRestoreStudyLabManagementRow={softDeleteRestoreStudyLabManagementRow}
        Title={"Deleted Test History"}
      />

      {/* Test Activities Offcanvas */}
      <Offcanvas
        show={!toggle3}
        onHide={setToggle3}
        placement="end"
        style={{ width: 900 }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Test Activities - {rowData?.row?.TESTNAME || rowData?.testId || ""}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <LabManagementActivities
            onMouseDown={onMouseDown}
            tableRef={tableRef}
            labManagementActivity={labManagementActivity}
            activityLoader={activityLoader}
            getStudyAuditTrials={getStudyAuditTrials}
            rowData={rowData}
            labManagementActivityCount={labManagementActivityCount}
          />
        </Offcanvas.Body>
      </Offcanvas>

      {/* Properties Offcanvas */}
      <Offcanvas
        show={!toggle4}
        onHide={setToggle4}
        placement="end"
        size="lg"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Properties - {rowData?.row?.TESTNAME || rowData?.testId || ""}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <LabManagementProperties
            onMouseDown={onMouseDown}
            tableRef={tableRef}
            rowData={rowData}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default LabManagementDataList;